import React from 'react'
import { Minus, Plus } from 'react-feather'

const FormDashboardInputNumber = ({placeholder, onChange = () => {}, className, defaultValue}) => {
  const input = React.createRef()

  React.useEffect(() => {
    if(defaultValue){
      input.current.value = defaultValue
    }
    //eslint-disable-next-line
  }, [defaultValue])

  const handleChange = (e) => {
    onChange(e.target.value)
  }

  const increment = () => {
    input.current.value++
    handleChange({target: {value: input.current.value}})
  }

  const decrement = () => {
    input.current.value--
    handleChange({target: {value: input.current.value}})
  }

  return (
    <div
      className={`custom-input-number text-sm rounded border bg-white flex justify-between items-center ${className}`}
      style={{borderColor: '#ddd'}}
    >
      <div className="p-2 lg:pl-4 cursor-pointer" onClick={decrement}>
        <Minus style={{width: '12px', height: '12px'}}/>
      </div>
      <input
        className="py-2 w-full text-center"
        placeholder={placeholder}
        onChange={handleChange}
        type="number"
        defaultValue={defaultValue}
        ref={input}
      />
      <div className="p-2 lg:pr-4 cursor-pointer" onClick={increment}>
        <Plus style={{width: '12px', height: '12px'}}/>
      </div>
    </div>
  )
}

export { FormDashboardInputNumber }
